// @ts-nocheck
// material-ui
import { Box, Stack, Typography } from '@mui/material';

// project import
import Profile from './Profile';
import Customization from './Customization';
import { useMe } from 'services/partner/api';

// front-end's HeaderContent without search, messages, notifications or the workspace
// switcher: a partner has one workspace, which is named on the left instead.
const HeaderContent = () => {
  const { data: me } = useMe();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', minWidth: 0 }}>
      <Stack direction="row" alignItems="center" spacing={0.75} sx={{ minWidth: 0, flex: 1, mr: 0.75 }}>
        <Typography
          noWrap
          sx={{ fontSize: '0.95rem', fontWeight: 700, color: 'var(--nv-text-strong, var(--nv-text-primary))', minWidth: 0 }}
        >
          {me?.partner.name ?? ''}
        </Typography>
      </Stack>

      <Stack direction="row" alignItems="center" spacing={0.75} sx={{ flexShrink: 0 }}>
        <Customization />
        <Profile />
      </Stack>
    </Box>
  );
};

export default HeaderContent;
